import React__default from 'react';
import { Benefits } from '../../common/benefits/Benefits.js';
import { Title } from '../../common/title/Title.js';
import styles from './NoOffer.module.scss.js';

const NoOffer = () => {
    return (React__default.createElement("div", { className: styles.wrapper, "data-testid": "no-offer-box" },
        React__default.createElement(Title, null),
        React__default.createElement(Benefits, null)));
};

export { NoOffer };
//# sourceMappingURL=NoOffer.js.map
